import React from "react";
import usePageMeta from "@/hooks/usePageMeta";
import { useI18n } from "@/i18n";
import { PageHero } from "@/components/PageHero";
import Contact from "@/components/sections/Contact";
import Directions from "@/components/sections/Directions";
import Booking from "@/components/sections/Booking";

export default function Kontakt() {
  const { t } = useI18n();
  usePageMeta(t.meta.kontakt.title, t.meta.kontakt.desc);
  return (
    <>
      <PageHero
        image="/images/kontakt-hero.webp"
        alt={t.pageHero.kontakt.alt}
        title={t.pageHero.kontakt.title}
        subtitle={t.pageHero.kontakt.subtitle}
        position="object-[center_38%]"
        parallax={false}
        heightClass="h-[62svh] min-h-[460px] md:h-[74svh]"
      />
      <Contact />
      <Booking />
      <Directions />
    </>
  );
}
